import { Box, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

interface FilterChipProps {
  label: string;
  onClick: () => void;
  checked: boolean;
}
const FilterChip = ({ label, onClick, checked }: FilterChipProps) => {
  const theme = useTheme();

  const dynamicStyles = useMemo(() => {
    return checked
      ? {
          background: theme.nawy.colors.semantic.layer.accentLight,
          border: `1px solid ${theme.nawy.colors.semantic.border.accent}`,
        }
      : {
          background: theme.nawy.colors.semantic.layer.primary,
          border: `1px solid ${theme.nawy.colors.semantic.border.primary}`,
        };
  }, [checked, theme]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.nawy.radius.lg,
        padding: `${theme.nawy.spacing.xs} ${theme.nawy.spacing.md}`,
        ...dynamicStyles,
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          ...theme.nawy.typography.english.variants.body.md.regular,
          color: theme.nawy.colors.semantic.text.accent,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FilterChip;
